import { Injectable } from '@angular/core';

import { UserUpdateInterface } from '@reach/interfaces/user/user.requests';
import { UserPinnedSearchParam } from '@reach/interfaces/user/user-pinned-search-param.type';
import {
	GetUserConflictsResponse,
	RequestDeletionEmailResponse,
	UpdateUserInfoResponse,
} from '@reach/interfaces/user/users.responses';
import {
	UserActionLimitsResponse,
	UserActionLimitsUpdateRequest,
} from '@reach/interfaces/users-action-limits/users-action-limits.types';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class UsersApiService extends BaseApiService {
	protected commonPath = ['users'];

	public async getUsernameConflicts(username: string): Promise<boolean> {
		const params = { username };

		return await this.http
			.get<GetUserConflictsResponse>(this.url('conflicts'), params)
			.then((response) => {
				return response.username || false;
			});
	}

	public async getEmailConflicts(email: string): Promise<boolean> {
		const params = { email };

		return await this.http
			.get<GetUserConflictsResponse>(this.url('conflicts'), params)
			.then((response) => {
				return response.email || false;
			});
	}

	public async increaseActionLimits(
		body: UserActionLimitsUpdateRequest
	): Promise<UserActionLimitsResponse> {
		return await this.http.patch<UserActionLimitsResponse>(
			this.url('me', 'action-limits', 'increase'),
			body
		);
	}

	public async getActionLimits(): Promise<UserActionLimitsResponse> {
		return await this.http.get<UserActionLimitsResponse>(this.url('me', 'action-limits'));
	}

	public async editData(data: Partial<UserUpdateInterface>): Promise<UpdateUserInfoResponse> {
		const body = data;
		return await this.http.patch<UpdateUserInfoResponse>(this.url('me', 'info'), body);
	}

	public async requestDelete(): Promise<RequestDeletionEmailResponse> {
		return await this.http.post<RequestDeletionEmailResponse>(this.url('me', 'request-delete'));
	}

	public async deleteUserWithToken(token: string): Promise<string> {
		return await this.http
			.delete<{ token: string }>(this.url('me'), {}, { 'x-access-token': token })
			.then((response) => {
				return response?.token;
			});
	}

	public async getPinnedSearchParams(): Promise<string[]> {
		return await this.http.get<string[]>(this.url('me', 'pinned-search-params'));
	}
	public async editPinnedSearchParams(params: string[]): Promise<void> {
		return await this.http.put<void>(this.url('me', 'pinned-search-params'), {
			pinnedSearchParams: params as UserPinnedSearchParam[],
		});
	}
}
